module.exports = __webpack_public_path__ + "static/media/logo.f54647e7.png";